/*
 * @Author: your name
 * @Date: 2020-12-22 14:43:51
 * @LastEditTime: 2022-01-20 14:56:18
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /ids-admin-web的副本/src/apis/user.js
 */
import createAPI from '@/common/createApi.js'
/**
 * config: 接口参数，
 * vconfig: （自定义参数）{
 *  neverLoading: 是否显示loading
 * }
 */
const api = '/we-api/user'
/*&verifyCode=55*/
/* const api = '' */
export default {
  // 获取邮箱验证码
  getEmailCode: (email, code, config = {}) =>
    createAPI(
      `${api}/v1/user/getEmailVerifyCode`,
      'get',
      {
        ...config,
        params: {
          email,
          verifyCode: code,
          ...(config.params || {})
        }
      },
      {
        isLoading: false,
        cryptoFields: {
          email: 1
        }
      }
    ),
  emailIsExist: (email, config) =>
    createAPI(
      `${api}/v1/user/checkEmailIsExist`,
      'get',
      {
        params: { email },
        ...config
      },
      {
        isLoading: false,
        cryptoFields: {
          email: 1
        }
      }
    ),
  getPhoneCode: (phone, code, config = {}) =>
    createAPI(
      `${api}/v1/user/getPhoneVerifyCode`,
      'get',
      {
        ...config,
        params: {
          phone,
          verifyCode: code,
          ...(config.params || {})
        }
      },
      {
        isLoading: false,
        cryptoFields: {
          phone: 1
        }
      }
    ),
  phoneIsExist: (phone, config) =>
    createAPI(
      `${api}/v1/user/checkPhoneIsExist`,
      'get',
      {
        params: { phone },
        ...config
      },
      {
        isLoading: false,
        cryptoFields: {
          phone: 1
        }
      }
    ),
  registerAuthor: config =>
    createAPI(`${api}/v1/user/register`, 'post', config, {
      isLoading: false,
      cryptoFields: {
        email: 1,
        emailCode: 1,
        bankupEmail: 1,
        contactMobile: 1,
        password: 1,
        phone: 1,
        realName: 1,
        verifyCode: 1
      }
    }),
  getImageCode: (identify, config = {}) =>
    createAPI(
      `${api}/v1/user/code/image/get`,
      'get',
      {
        ...config,
        params: {
          identify,
          ...(config.params || {})
        }
      },
      {
        isLoading: false,
        neverLoading: true,
        cryptoFields: {
          identify: 1
        }
      }
    ),
  checkImageCode: (identify, code, config = {}) =>
    createAPI(
      `${api}/v1/user/code/image/check`,
      'get',
      {
        ...config,
        params: {
          identify,
          code,
          ...(config.params || {})
        }
      },
      {
        isLoading: false,
        cryptoFields: {
          identify: 1
        }
      }
    )
}
